import React, { Fragment } from "react";
import { Container, Row, Col } from "react-bootstrap";

const Privecy_Policy = () => {
  return (
    <Fragment>
      <div className="privacy-page">
        <Container className="py-5">
          <Row>
            <Col md={12} className="mb-5">
              <div className="privacy-header text-center">
                {/* <h1 className="mb-3">Privacy Policy</h1> */}
                <p className="text-muted">
                  <strong>Last Updated: January 2025</strong>
                </p>
                <p>
                  Spark Lab ("we," "us," or "our") respects your privacy and is
                  committed to protecting your personal data. This Privacy
                  Policy explains how we collect, use, disclose, and safeguard
                  your information when you visit our website
                  https://sparklabpk.com or use our services.
                </p>
              </div>
            </Col>

            <Col md={12} className="mb-4">
              <div className="privacy-box">
                <h3>1. Information We Collect</h3>
                <p className="mb-3">
                  We collect several types of information from and about users
                  of our services:
                </p>

                <h5>Personal Data:</h5>
                <ul className="mb-3">
                  <li>
                    <strong>Identity Data:</strong> Name, username, or similar
                    identifier
                  </li>
                  <li>
                    <strong>Contact Data:</strong> Email address, phone number,
                    address
                  </li>
                  <li>
                    <strong>Technical Data:</strong> IP address, browser type
                    and version, time zone setting, browser plug-in types and
                    versions, operating system and platform
                  </li>
                  <li>
                    <strong>Usage Data:</strong> Information about how you use
                    our website and services
                  </li>
                  <li>
                    <strong>Marketing and Communications Data:</strong> Your
                    preferences in receiving marketing from us and your
                    communication preferences
                  </li>
                  <li>
                    <strong>SMS/Text Messaging Data:</strong> Phone numbers and
                    consent records for transactional and marketing
                    communications
                  </li>
                </ul>

                <h5>How We Collect Information:</h5>
                <ul>
                  <li>
                    <strong>Directly from you</strong> when you:
                    <ul>
                      <li>Fill out forms on our website</li>
                      <li>Subscribe to our services</li>
                      <li>Request information or support</li>
                      <li>Opt into SMS/text messaging communications</li>
                      <li>
                        Communicate with us via email, phone, or otherwise
                      </li>
                    </ul>
                  </li>
                  <li>
                    <strong>Automatically</strong> as you navigate through the
                    site using cookies and similar technologies
                  </li>
                  <li>
                    <strong>From third parties</strong> such as analytics
                    providers and advertising networks
                  </li>
                </ul>
              </div>
            </Col>

            <Col md={12} className="mb-4">
              <div className="privacy-box">
                <h3>2. How We Use Your Information</h3>
                <p>We use your information for the following purposes:</p>

                <h5>Service Delivery:</h5>
                <ul className="mb-3">
                  <li>To provide and maintain our services</li>
                  <li>To process your requests and transactions</li>
                  <li>To communicate with you about your projects</li>
                  <li>
                    To send project updates, meeting confirmations, and support
                    responses
                  </li>
                </ul>

                <h5>Business Operations:</h5>
                <ul className="mb-3">
                  <li>
                    To improve our website, services, and customer experience
                  </li>
                  <li>To conduct data analysis and research</li>
                  <li>To monitor usage trends and preferences</li>
                </ul>

                <h5>Marketing and Communications:</h5>
                <ul className="mb-3">
                  <li>
                    To send promotional materials about Spark Lab products and
                    services (only with your consent)
                  </li>
                  <li>
                    To administer SMS/text messaging campaigns for transactional
                    and marketing communications as per your opt-in preferences
                  </li>
                  <li>
                    To respond to your inquiries and provide customer support
                  </li>
                </ul>

                <h5>Legal and Compliance:</h5>
                <ul>
                  <li>To comply with legal obligations</li>
                  <li>To protect our rights, privacy, safety, or property</li>
                  <li>To prevent fraud and ensure security</li>
                </ul>
              </div>
            </Col>

            <Col md={12} className="mb-4">
              <div className="privacy-box">
                <h3>3. Data Sharing and Security</h3>

                <h5>Data Sharing:</h5>
                <p className="mb-3">
                  We do not sell, rent, or trade your personal information to
                  third parties for their marketing purposes. We may share your
                  information with:
                </p>
                <ul className="mb-3">
                  <li>
                    <strong>Service Providers:</strong> Trusted third parties
                    who assist us in operating our website, conducting our
                    business, or servicing you
                  </li>
                  <li>
                    <strong>Legal Requirements:</strong> When required by law or
                    to respond to legal process
                  </li>
                  <li>
                    <strong>Business Transfers:</strong> In connection with any
                    merger, sale of company assets, or acquisition
                  </li>
                </ul>

                <h5>SMS/Text Messaging Data Sharing:</h5>
                <p className="mb-3">
                  <strong>
                    No mobile information will be shared with any third
                    parties/affiliates for marketing/promotional purposes.
                  </strong>{" "}
                  All other categories exclude text messaging originator opt-in
                  data and consent; this information will not be shared with or
                  obtained by any third parties.
                </p>

                <h5>Data Security:</h5>
                <p>
                  We implement appropriate technical and organizational security
                  measures to protect your personal data against unauthorized
                  access, alteration, disclosure, or destruction. However, no
                  internet transmission is completely secure, and we cannot
                  guarantee absolute security.
                </p>
              </div>
            </Col>

            <Col md={12} className="mb-4">
              <div className="privacy-box">
                <h3>4. Cookies and Tracking Technologies</h3>
                <p>We use cookies and similar tracking technologies to:</p>
                <ul>
                  <li>Enhance your browsing experience</li>
                  <li>Analyze website traffic and usage patterns</li>
                  <li>Personalize content and advertisements</li>
                  <li>
                    Understand the effectiveness of our marketing campaigns
                  </li>
                </ul>
                <p className="mt-3">
                  You can control cookies through your browser settings.
                  However, disabling cookies may affect your ability to use
                  certain features of our website.
                </p>
              </div>
            </Col>

            <Col md={12} className="mb-4">
              <div className="privacy-box">
                <h3>5. SMS/Text Messaging Privacy Policy</h3>
                <p>
                  <strong>
                    No mobile information will be shared with any third
                    parties/affiliates for marketing/promotional purposes.
                  </strong>{" "}
                  All other categories exclude text messaging originator opt-in
                  data and consent; this information will not be shared with or
                  obtained by any third parties.
                </p>
                <p className="mt-3">
                  If you wish to be removed from receiving future
                  communications, you can opt out at any time by texting STOP or
                  contacting us at{" "}
                  <a href="mailto:hr@sparklabpk.com">hr@sparklabpk.com</a>.
                </p>
              </div>
            </Col>

            <Col md={12} className="mb-4">
              <div className="privacy-box">
                <h3>6. Your Rights</h3>
                <p className="mb-3">
                  Depending on your location, you may have the following rights
                  regarding your personal data:
                </p>

                <h5>Access and Correction:</h5>
                <ul className="mb-3">
                  <li>Request access to your personal data</li>
                  <li>Request correction of inaccurate or incomplete data</li>
                  <li>Request deletion of your personal data</li>
                </ul>

                <h5>Marketing Preferences:</h5>
                <ul className="mb-3">
                  <li>Opt out of marketing communications at any time</li>
                  <li>Adjust your cookie preferences</li>
                  <li>
                    Withdraw consent for SMS/text messaging by replying STOP
                  </li>
                </ul>

                <h5>How to Exercise Your Rights:</h5>
                <p>
                  To exercise any of these rights, please contact us at{" "}
                  <a href="mailto:hr@sparklabpk.com">hr@sparklabpk.com</a>. We
                  will respond to your request within a reasonable timeframe.
                </p>
              </div>
            </Col>

            <Col md={12} className="mb-4">
              <div className="privacy-box">
                <h3>7. Data Retention</h3>
                <p>
                  We retain your personal data only for as long as necessary to
                  fulfill the purposes for which it was collected, including for
                  satisfying legal, accounting, or reporting requirements. SMS
                  opt-in data and consent records are retained as required by
                  telecommunications regulations.
                </p>
              </div>
            </Col>

            <Col md={12} className="mb-4">
              <div className="privacy-box">
                <h3>8. International Data Transfers</h3>
                <p>
                  Your information may be transferred to and maintained on
                  computers located outside of your country where data
                  protection laws may differ. By using our services, you consent
                  to such transfers.
                </p>
              </div>
            </Col>

            <Col md={12} className="mb-4">
              <div className="privacy-box">
                <h3>9. Children's Privacy</h3>
                <p>
                  Our services are not intended for individuals under 18 years
                  of age. We do not knowingly collect personal data from
                  children under 18. If you become aware that a child has
                  provided us with personal data, please contact us.
                </p>
              </div>
            </Col>

            <Col md={12} className="mb-4">
              <div className="privacy-box">
                <h3>10. Changes to This Policy</h3>
                <p>
                  We may update this Privacy Policy from time to time. We will
                  notify you of any changes by posting the new Privacy Policy on
                  this page and updating the "Last Updated" date. You are
                  advised to review this Privacy Policy periodically for any
                  changes.
                </p>
              </div>
            </Col>

            <Col md={12} className="mb-4">
              <div className="privacy-box">
                <h3>11. Contact Us</h3>
                <p>
                  If you have any questions about this Privacy Policy, please
                  contact us:
                </p>
                <ul>
                  <li>
                    <strong>Email:</strong>{" "}
                    <a href="mailto:hr@sparklabpk.com">hr@sparklabpk.com</a>
                  </li>
                  <li>
                    <strong>Phone:</strong> +92 3335855502
                  </li>
                  <li>
                    <strong>Address:</strong> Plot 19 E Baddar Commercial Street
                    No. 5, Clifton, Karachi, Sindh 75500, Pakistan
                  </li>
                </ul>
              </div>
            </Col>

            <Col md={12} className="mb-4">
              <div className="privacy-box">
                <h3>12. SMS/Text Messaging Privacy Policy</h3>
                <p>
                  No mobile information will be shared with any third
                  parties/affiliates for marketing/promotional purposes. All
                  other categories exclude text messaging originator opt-in data
                  and consent; this information will not be shared with or
                  obtained by any third parties. If you wish to be removed from
                  receiving future communications, you can opt out at any time
                  by texting STOP or contacting us at hr@sparklabpk.com.
                </p>
                {/* <ul>
                  <li>
                    <strong>Email:</strong>{" "}
                    <a href="mailto:hr@sparklabpk.com">hr@sparklabpk.com</a>
                  </li>
                  <li>
                    <strong>Phone:</strong> +92 3335855502
                  </li>
                  <li>
                    <strong>Address:</strong> Plot 19 E Baddar Commercial Street
                    No. 5, Clifton, Karachi, Sindh 75500, Pakistan
                  </li>
                </ul> */}
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </Fragment>
  );
};

export default Privecy_Policy;
